import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/table";
import { TailSpin } from "react-loader-spinner";
import { Modal } from "antd";
import Icon from "../../../assets/icons";
import { format } from "date-fns";

const DeductionTable = ({
  data,
  selectedStatus,
  handleStatusChange,
  loading,
}: any) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedDeduction, setSelectedDeduction] = useState(null);
  const columns = [
    {
      header: "Account Name",
      accessor: "fullname",
      render: (row: any) => <p className="capitalize">{row.user?.fullname || "N/A"}</p>,
    },
    {
      header: "Amount",
      accessor: "amount",
      render: (row: any) => <p className="">NGN {row.amount}</p>,
    },
    { header: "Reason", accessor: "reason" },
    { header: "Date", accessor: "created_at" },
    {
      header: " ",
      accessor: "action",
      render: (row: any) => (
        <button
          onClick={() => {
            setShowModal(true);
            setSelectedDeduction(row);
          }}
        >
          View
        </button>
      ),
    },
  ];

  // const handleUserClick = (id: string) => {
  //   navigate(`/request/${id}`);
  // };

  // const mappedData = filteredData.map((request: any) => ({
  //   ...request,
  //   fullName: request?.assignedTo?.fullname || "N/A",
  // }));

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All Deductions</p>
        <div className="flex gap-2">
          <span className="text-[14px] font-medium">Filter by:</span>
          <select
            className="border text-[12px] px-3 py-1 rounded bg-[#0979A1] text-white"
            value={selectedStatus}
            onChange={handleStatusChange}
          >
            <option value="">All</option>
            <option value="resolved">Resolved</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : data.length > 0 ? (
        <Table
          columns={columns}
          data={data}
          selectedUserId={null}
          onUserClick={() => {}}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}
      {showModal && (
        <DeductionModal
          showModal={showModal}
          setShowModal={setShowModal}
          data={selectedDeduction}
        />
      )}
    </div>
  );
};

const DeductionModal = ({ showModal, setShowModal, data }: any) => {
  return (
    <Modal
      open={showModal}
      onCancel={() => setShowModal(false)}
      centered
      width={400}
      footer={null}
      style={{
        padding: "0px",
      }}
      className=""
    >
      <div className="flex flex-col gap-4 !p-0">
        <div className="flex justify-between">
          <p className="text-xs font-semibold"> Details</p>
          <button onClick={() => setShowModal(false)}>
            <Icon name="cancel" />
          </button>
        </div>
        <div className="border-t py-4 flex flex-col gap-2">
          <div className="flex items-center justify-between gap-2">
            <p className="text-xs text-gray-500 font-medium">Amount deducted</p>
            <p className="text-xs">
              {format(new Date(data?.updated_at), "MMMM d, yyyy h:mm a")}
            </p>
          </div>
          <p className="text-base font-medium">₦ {data?.amount}</p>
          <div className="border p-4 rounded-2xl text-xs flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <p className="font-medium">Admin:</p>
              <p className="text-gray-500 font-medium">
                {data?.admin?.fullname}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <p className="font-medium">Reason: </p>
              <p className="text-gray-500 font-medium">{data?.reason}</p>
            </div>
            <div className="flex items-center gap-2">
              <p className="font-medium">Note: </p>
              <p className="text-gray-500 font-medium">{data?.note || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeductionTable;
